import api from '@/services/api';

const actions = {
  async getLayerFavoriteFilters(store, layerId) {
    const r = await api.get(`v2/filter-expressions/${layerId}`);
    return r.data.data;
  },
  async addLayerFavoriteFilter({ dispatch }, { layerId, payload }) {
    const id = (await api.post(`v2/filter-expressions/${layerId}`, payload)).data.data;
    const r = await dispatch('getLayerFavoriteFilters', layerId);
    return { newId: id, filters: r };
  },
  async deleteLayerFavoriteFilter({ dispatch }, { layerId, filterId }) {
    await api.delete(`v2/filter-expressions/${filterId}`);
    if (layerId) return await dispatch('getLayerFavoriteFilters', layerId);
  },
  async editLayerFavoriteFilter({ dispatch }, { layerId, filterId, payload }) {
    await api.put(`v2/filter-expressions/${filterId}`, payload);
    if (layerId) return await dispatch('getLayerFavoriteFilters', layerId);
  },
};

export default {
  namespaced: true,
  actions,
};
